import styled from "@emotion/styled";

export const LogoImg = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 8px;
`;
